import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getUserToken } from "../utils";
import request, { useSubmitTime } from "./request";
export var EasySaveBonus;
(function (EasySaveBonus) { EasySaveBonus["CARING"] = "CARING"; EasySaveBonus["LOYALTY"] = "LOYALTY"; })(EasySaveBonus || (EasySaveBonus = {}));
export var PlanLevel;
(function (PlanLevel) { PlanLevel[PlanLevel["ENTRY"] = 0] = "ENTRY"; PlanLevel[PlanLevel["STANDARD"] = 1] = "STANDARD"; PlanLevel[PlanLevel["PREMIUM"] = 2] = "PREMIUM"; })(PlanLevel || (PlanLevel = {}));
export function getImmediateQuote(_x) { return _getImmediateQuote.apply(this, arguments); }
function _getImmediateQuote() { _getImmediateQuote = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data) { var resp; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return request.post("/api/v1/quotation/quoteMain/immediateQuote", Object.assign({}, data, { quoteNo: data.quoteNo || undefined, useSubmitTime: true }));
        case 2:
            resp = _context.sent;
            if (resp.data.result) {
                _context.next = 5;
                break;
            }
            throw resp.data;
        case 5: return _context.abrupt("return", resp.data);
        case 6:
        case "end": return _context.stop();
    }
} }, _callee); })); return _getImmediateQuote.apply(this, arguments); }
export function getExchangeRate() { return _getExchangeRate.apply(this, arguments); } // export interface ApiGetQuoteNoResult {
//   quoteNo: string;
//   userToken: string;
// }
function _getExchangeRate() { _getExchangeRate = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2() { var resp; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return request.post("/api/v1/quotation/getExchangeRate", { useSubmitTime: true });
        case 2:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.data);
        case 4:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _getExchangeRate.apply(this, arguments); }
export function getQuoteNo(_x2) { return _getQuoteNo.apply(this, arguments); }
function _getQuoteNo() { _getQuoteNo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(req) { var resp; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            _context3.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/initQuote/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context3.sent;
            return _context3.abrupt("return", resp.data);
        case 4:
        case "end": return _context3.stop();
    }
} }, _callee3); })); return _getQuoteNo.apply(this, arguments); }
export var MinAgeAttr;
(function (MinAgeAttr) { MinAgeAttr["Age"] = "A"; MinAgeAttr["Day"] = "D"; })(MinAgeAttr || (MinAgeAttr = {}));
export function getIndustryAndOccupationList(_x3) { return _getIndustryAndOccupationList.apply(this, arguments); }
function _getIndustryAndOccupationList() { _getIndustryAndOccupationList = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(productCode) { var resp; return _regeneratorRuntime.wrap(function _callee4$(_context4) { while (1) {
    switch (_context4.prev = _context4.next) {
        case 0:
            _context4.next = 2;
            return request.post("/api/v1/quotation/getIndustryAndOccupationList", { productCode: productCode, useSubmitTime: true });
        case 2:
            resp = _context4.sent;
            return _context4.abrupt("return", resp.data);
        case 4:
        case "end": return _context4.stop();
    }
} }, _callee4); })); return _getIndustryAndOccupationList.apply(this, arguments); }
export function getSourcesOfFunds() { return _getSourcesOfFunds.apply(this, arguments); }
function _getSourcesOfFunds() { _getSourcesOfFunds = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5() { var resp; return _regeneratorRuntime.wrap(function _callee5$(_context5) { while (1) {
    switch (_context5.prev = _context5.next) {
        case 0:
            _context5.next = 2;
            return request.post("/api/v1/quotation/product/ajaxGetSourcesOfFunds", { sof: "SourcesOfFunds", useSubmitTime: true });
        case 2:
            resp = _context5.sent;
            return _context5.abrupt("return", resp.data);
        case 4:
        case "end": return _context5.stop();
    }
} }, _callee5); })); return _getSourcesOfFunds.apply(this, arguments); }
export function getCountryInfo(_x4) { return _getCountryInfo.apply(this, arguments); }
function _getCountryInfo() { _getCountryInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6(countryType) { var resp; return _regeneratorRuntime.wrap(function _callee6$(_context6) { while (1) {
    switch (_context6.prev = _context6.next) {
        case 0:
            _context6.next = 2;
            return request.post("/api/v1/quotation/product/ajaxGetcountryInfo", { countryType: countryType, useSubmitTime: true });
        case 2:
            resp = _context6.sent;
            return _context6.abrupt("return", resp.data);
        case 4:
        case "end": return _context6.stop();
    }
} }, _callee6); })); return _getCountryInfo.apply(this, arguments); }
export function getQuoteInfo(_x5) { return _getQuoteInfo.apply(this, arguments); } //刪除失效優惠碼
function _getQuoteInfo() { _getQuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7(req) { var resp; return _regeneratorRuntime.wrap(function _callee7$(_context7) { while (1) {
    switch (_context7.prev = _context7.next) {
        case 0:
            _context7.next = 2;
            return request.post("/api/v1/quotation/quoteMain/getQuoteInfo", Object.assign({}, req, { useSubmitTime: true }));
        case 2:
            resp = _context7.sent;
            if (resp.data.result) {
                _context7.next = 5;
                break;
            }
            throw resp.data;
        case 5: return _context7.abrupt("return", resp.data);
        case 6:
        case "end": return _context7.stop();
    }
} }, _callee7); })); return _getQuoteInfo.apply(this, arguments); }
export function deleteDiscountCode(_x6) { return _deleteDiscountCode.apply(this, arguments); }
function _deleteDiscountCode() { _deleteDiscountCode = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee8(req) { var resp; return _regeneratorRuntime.wrap(function _callee8$(_context8) { while (1) {
    switch (_context8.prev = _context8.next) {
        case 0:
            _context8.next = 2;
            return request.post("/api/v1/quotation/quoteMain/deleteDiscountCode", Object.assign({}, req, { useSubmitTime: true, invalid: "1" }));
        case 2:
            resp = _context8.sent;
            return _context8.abrupt("return", resp.data);
        case 4:
        case "end": return _context8.stop();
    }
} }, _callee8); })); return _deleteDiscountCode.apply(this, arguments); }
export function getQuoteInfoSummary(_x7) { return _getQuoteInfoSummary.apply(this, arguments); }
function _getQuoteInfoSummary() { _getQuoteInfoSummary = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee9(req) { var resp; return _regeneratorRuntime.wrap(function _callee9$(_context9) { while (1) {
    switch (_context9.prev = _context9.next) {
        case 0:
            _context9.next = 2;
            return request.post("/api/v1/quotation/quoteMain/getQuoteInfo/getSummary", Object.assign({}, req, { useSubmitTime: true }));
        case 2:
            resp = _context9.sent;
            return _context9.abrupt("return", resp.data);
        case 4:
        case "end": return _context9.stop();
    }
} }, _callee9); })); return _getQuoteInfoSummary.apply(this, arguments); }
export function getQuoteInfoPayment(_x8) { return _getQuoteInfoPayment.apply(this, arguments); }
function _getQuoteInfoPayment() { _getQuoteInfoPayment = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee10(req) { var resp; return _regeneratorRuntime.wrap(function _callee10$(_context10) { while (1) {
    switch (_context10.prev = _context10.next) {
        case 0:
            _context10.next = 2;
            return request.post("/api/v1/quotation/quoteMain/getQuoteInfo/payment/" + req.productCode, Object.assign({}, req, { useSubmitTime: true }));
        case 2:
            resp = _context10.sent;
            return _context10.abrupt("return", resp.data);
        case 4:
        case "end": return _context10.stop();
    }
} }, _callee10); })); return _getQuoteInfoPayment.apply(this, arguments); } // export type ApiSaveQuoteToUserResult = boolean;
export function saveQuoteToUser(_x9) { return _saveQuoteToUser.apply(this, arguments); }
function _saveQuoteToUser() { _saveQuoteToUser = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee11(req) { var resp; return _regeneratorRuntime.wrap(function _callee11$(_context11) { while (1) {
    switch (_context11.prev = _context11.next) {
        case 0:
            _context11.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuoteToUser/" + req.productCode, Object.assign({}, req, { useSubmitTime: true }));
        case 2:
            resp = _context11.sent;
            return _context11.abrupt("return", resp.data);
        case 4:
        case "end": return _context11.stop();
    }
} }, _callee11); })); return _saveQuoteToUser.apply(this, arguments); }
export function saveQuoteConfirm(_x10) { return _saveQuoteConfirm.apply(this, arguments); }
function _saveQuoteConfirm() { _saveQuoteConfirm = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee12(req) { var resp; return _regeneratorRuntime.wrap(function _callee12$(_context12) { while (1) {
    switch (_context12.prev = _context12.next) {
        case 0:
            _context12.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/confirmedTnc/" + req.productCode, Object.assign({}, req, { useSubmitTime: true }));
        case 2:
            resp = _context12.sent;
            return _context12.abrupt("return", resp.data);
        case 4:
        case "end": return _context12.stop();
    }
} }, _callee12); })); return _saveQuoteConfirm.apply(this, arguments); }
export function generateBenefitIllustration(_x11, _x12, _x13) { return _generateBenefitIllustration.apply(this, arguments); }
function _generateBenefitIllustration() { _generateBenefitIllustration = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee13(quoteNo, language, productCode) { var url, method, body; return _regeneratorRuntime.wrap(function _callee13$(_context13) { while (1) {
    switch (_context13.prev = _context13.next) {
        case 0:
            if (productCode === "BBUSTR00") {
                url = encodeURI("/api/v1/report/generateMsBenefitIllustrationReport" + "?quoteNo=" + quoteNo + "&productCode=" + productCode + "&language=" + language);
                method = "get";
                body = null;
            }
            else if (productCode === "BBNEDS30") {
                url = encodeURI("/api/v1/report/generateStBenefitIllustrationReport" + "?quoteNo=" + quoteNo + "&productCode=" + productCode + "&language=" + language);
                method = "get";
                body = null;
            }
            else if (productCode === "BBNRCR00") {
                url = encodeURI("/api/v1/report/generateRopBenefitIllustrationReport" + "?quoteNo=" + quoteNo + "&productCode=" + productCode + "&language=" + language);
            }
            else {
                url = "/api/v1/quotation/sale/generateBenefitIllustration";
                method = "post";
                body = JSON.stringify(Object.assign({ quoteNo: quoteNo, userToken: getUserToken(quoteNo) }, useSubmitTime()));
            }
            _context13.prev = 1;
            _context13.next = 4;
            return fetch(url, { method: method, headers: { "Content-Type": "application/json", "Accept-Language": language }, body: body }).then(function (v) { return v.arrayBuffer(); }).then(function (arrayBuffer) { return new Uint8Array(arrayBuffer); });
        case 4: return _context13.abrupt("return", _context13.sent);
        case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](1);
            console.error(_context13.t0);
            return _context13.abrupt("return", null);
        case 11:
        case "end": return _context13.stop();
    }
} }, _callee13, null, [[1, 7]]); })); return _generateBenefitIllustration.apply(this, arguments); }
export function genPromotionCode(_x14) { return _genPromotionCode.apply(this, arguments); } //phase 2.1
function _genPromotionCode() { _genPromotionCode = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee14(req) { var resp; return _regeneratorRuntime.wrap(function _callee14$(_context14) { while (1) {
    switch (_context14.prev = _context14.next) {
        case 0:
            _context14.next = 2;
            return request.post("/api/v1/quotation/genPromotionCode", req);
        case 2:
            resp = _context14.sent;
            return _context14.abrupt("return", resp.data);
        case 4:
        case "end": return _context14.stop();
    }
} }, _callee14); })); return _genPromotionCode.apply(this, arguments); }
export function savePlanSelection(_x15) { return _savePlanSelection.apply(this, arguments); } // export async function checkSummary(req: QnbAPIRequest) {
//   const resp = await request.post<BaseResponse<QnbAPIResponse>>(
//     "/api/v1/quotation/quoteMain/saveQuoteInfo/checkSummary/",
//     req
//   );
//   return resp.data;
// }
function _savePlanSelection() { _savePlanSelection = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee15(req) { var resp; return _regeneratorRuntime.wrap(function _callee15$(_context15) { while (1) {
    switch (_context15.prev = _context15.next) {
        case 0:
            _context15.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/savePlanSelection/", req);
        case 2:
            resp = _context15.sent;
            return _context15.abrupt("return", resp.data);
        case 4:
        case "end": return _context15.stop();
    }
} }, _callee15); })); return _savePlanSelection.apply(this, arguments); }
